var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-container"},[_c('div',{staticClass:"switch-label"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"click":function($event){return _vm.$emit('update:checked', $event.target.checked)}}}),_vm._v(" "),_c('span',{staticClass:"slider"})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f05365f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-elements/ToggleSwitch.vue
// module id = null
// module chunks = 